// vanData.js
export const vans = [
    { name: 'Modest Explorer', type: 'Cargo', seats: 2, price: '$60/day' },
    { name: 'Beach Bum', type: 'Passenger', seats: 6, price: '$80/day' },
    { name: 'Reliable Red', type: 'Cargo', seats: 4, price: '$100/day' },
    { name: 'Dream Finder', type: 'Passenger', seats: 8, price: '$65/day' },
    { name: 'The Cruiser', type: 'Passenger', seats: 9, price: '$120/day' },
    { name: 'Green Wonder', type: 'Passenger', seats: 12, price: '$70/day' },
  ];
  